import {getQuery} from "@/modules/common/utils";

const list = async (params) => getQuery('payment_statuses', params)
const get = uid => getQuery(`payment_statuses/${uid}`);

export default {
  list,
  get
}
